import React from 'react';
import Nav from '../layouts/Nav';
import Footer from '../layouts/Footer';
import UserProfile from './UserProfile';
import ChangePassword from './ChangePassword';
import { useUser } from '../../hooks/user/useUser';

const Profile = () => {
  const [{ user, isLoading, isSuccess }, editProfile] = useUser();

  const updateProfile = async (profile, id) => {
    editProfile(profile, id);
  };

  return (
    <span>
      <Nav />
      <hr className="mt-0 mb-3 d-flex d-md-none" />
      <div className="container" id="content">
        <div className="row">
          <div className="col-12 col-md-10 m-auto offset-md-3">
            <div className="section_tab">
              <nav className="col-md-12">
                <div
                  className="nav nav-tabs nav-fill"
                  id="nav-tab"
                  role="tablist"
                >
                  <a
                    className="nav-item nav-link active text-left p-0"
                    id="nav-profile-tab"
                    data-toggle="tab"
                    href="#nav-profile"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="true"
                  >
                    Profile Details
                  </a>
                  <a
                    className="nav-item nav-link text-center p-0"
                    id="nav-password-tab"
                    data-toggle="tab"
                    href="#nav-password"
                    role="tab"
                    aria-controls="nav-password"
                    aria-selected="false"
                  >
                    Change Password
                  </a>
                </div>
              </nav>
              <div className="tab-content" id="nav-tabContent">
                <UserProfile
                  currentUser={user}
                  editProfile={updateProfile}
                  load={isLoading}
                  success={isSuccess}
                />
                <ChangePassword />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </span>
  );
};

export default Profile;
